import { FC } from 'react'
import { useTenant } from './contexts/tenant/TenantContext'

const TenantFavicon: FC = () => {
  const { tenant } = useTenant()
  return (
    <>
      <link rel="icon" href={tenant.logo} />
      <link rel="apple-touch-icon" href={tenant.logo} />
    </>
  )
}

type TenantFaviconType = { Favicon: typeof TenantFavicon }

export { TenantFavicon, type TenantFaviconType }
